export function debitRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_DEBIT_START":           
        case "FETCH_DEBITS_START":                                 
        case "RECALC_DEBITS_START":                                 
        case "UPDATE_DEBIT_START":                                 
        case "DELETE_DEBIT_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_DEBIT_FULFILLED":           
        case "FETCH_DEBITS_FULFILLED":                                 
        case "RECALC_DEBITS_FULFILLED":                                 
        case "UPDATE_DEBIT_FULFILLED":                                 
        case "DELETE_DEBIT_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_DEBIT_ERROR":
        case "FETCH_DEBITS_ERROR":
        case "RECALC_DEBITS_ERROR":
        case "UPDATE_DEBIT_ERROR":
        case "DELETE_DEBIT_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}